import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ReportAccessList, ReportListModel } from '../../../../../../shared/models/report.model';
import { SubSink } from 'subsink';
import { ReportService } from '../../../../../../shared/service/report.service';
import { finalize } from 'rxjs/operators';
import { UserService } from '../../../../../../shared/service/user.service';
import { User } from '../../../../../../shared/models/user.model';
import { Role } from '../../../../../../shared/models/role.model';
import { NbDialogService } from '@nebular/theme';
import Swal from 'sweetalert2';
import { HttpError } from '../../../../../../shared/models/http-error.model';

@Component({
  selector: 'app-report-access-list',
  templateUrl: './report-access-list.component.html',
  styleUrls: ['./report-access-list.component.scss']
})
export class ReportAccessListComponent implements OnInit, OnDestroy {

  private _sub = new SubSink();
  @ViewChild('AdminListTemplate') adminListTemplate!: TemplateRef<any>;
  @ViewChild('ScopeListTemplate') scopeListTemplate!: TemplateRef<any>;
  private Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  constructor(private reportService: ReportService, private adminUserService: UserService, private dialogService: NbDialogService) {
  }

  reportsAccessList!: ReportAccessList[];
  getReportAccessListLoading = false;
  users: User[] = [];
  scopes: Role[] = [];
  searchUserQuery!: string;
  searchScopeQuery!: string;
  accessLoading = false;
  selectedReport!: ReportAccessList;
  removeAccessLoading = false;
  selectedRemoveType!: 'scope' | 'user';
  selectedAddType!: 'scope' | 'user';
  searchQuery!: string;

  getReportAccessList() {
    this.getReportAccessListLoading = true;
    this._sub.sink = this.reportService.getReportAccessList().pipe(finalize(() => this.getReportAccessListLoading = false)).subscribe(list => {
      this.reportsAccessList = list;
    });
  }

  getAdminUserList() {
    this.adminUserService.getAdminUserList().subscribe(users => {
      this.users = users;
    });
  }

  getScopeList() {
    this.adminUserService.getAdminUserLevels().subscribe(scopes => {
      this.scopes = scopes;
    });
  }

  addUserPermission(user: User) {
    this.accessLoading = true;
    this.reportService.grantUserToReport(this.selectedReport.id, user.id).subscribe(() => {
      this.Toast.fire({
        icon: 'success',
        text: `دسترسی ${user.firstName} ${user.lastName} به گزارش ${this.selectedReport.name} با موفقیت ایجاد شد.`
      });
      this.getReportAccessList();
      this.accessLoading = false;

    }, (response: HttpError) => {
      if (response.error) {
        this.Toast.fire({ icon: 'error', text: response.error });
      }
      this.accessLoading = false;
    });
  }

  addScopePermission(scope: Role) {
    this.accessLoading = true;
    this.reportService.grantScopeToReport(this.selectedReport.id, scope.id).subscribe(() => {
      this.Toast.fire({
        icon: 'success',
        text: `دسترسی سطح ${scope.name} به گزارش ${this.selectedReport.name} با موفقیت ایجاد شد.`
      });
      this.getReportAccessList();
      this.accessLoading = false;

    }, (response: HttpError) => {
      if (response.error) {
        this.Toast.fire({ icon: 'error', text: response.error });
      }
      this.accessLoading = false;
    });
  }

  removeAccess(report: ReportAccessList, id: string | number, type: 'scope' | 'user') {
    this.selectedReport = report;
    this.removeAccessLoading = true;
    this.selectedRemoveType = type;
    return this.reportService.removeAccess(report.id, id, type).subscribe(() => {
      this.removeAccessLoading = false;
      this.Toast.fire({ icon: 'success', text: `دسترسی با موفقیت حذف شد.` });
      this.getReportAccessList();

    }, (response: HttpError) => {
      if (response.error) {
        this.Toast.fire({ icon: 'error', text: response.error });
      }
      this.removeAccessLoading = false;
    });
  }

  addNewUser(report: ReportAccessList) {
    this.selectedReport = report;
    this.selectedAddType = 'user';
    this.dialogService.open(this.adminListTemplate);
  }

  addNewScope(report: ReportAccessList) {
    this.selectedReport = report;
    this.selectedAddType = 'scope';
    this.dialogService.open(this.scopeListTemplate);
  }

  ngOnInit(): void {
    this.getReportAccessList();
    this.getAdminUserList();
    this.getScopeList();
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }
}
